type AboutShape = { readonly about: readonly unknown[] };

/** The "about" label is required only while the type is about some population: its field is hidden otherwise. */
function isAboutLabelValid<T extends AboutShape>(value: string, formData: T): boolean {
	return formData.about.length === 0 || value.trim().length > 0;
}

export default isAboutLabelValid;
